export default {"src":"/_next/static/image/public/images/ic_records_grey_vertical_menu.a8139d64add0ecdfd25028db33137876.svg","height":20,"width":20};